import { Component, Input, OnDestroy, OnInit, AfterViewInit, ViewChild, SimpleChanges, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy, DoCheck, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { SurveyService } from "../shared/survey.services";
import { SurveyConfig, ResultSurvey } from "../shared/survey.model";
import { Validators } from "@angular/forms";
import { OperationResult } from "../../core/models/operation-result.model";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { LanguagePipe } from "app/core/language-resource/language.pipe";
//import { DynamicFormComponent } from "app/core/dynamic-form/containers/dynamic-form/dynamic-form.component";
//import { FieldConfig } from "app/core/dynamic-form/models/field-config.interface";

@Component({
  moduleId: module.id,
  selector: 'bp-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css'],
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1, transform: 'scale(1.0)' })),
      state('hidden', style({ opacity: 0, transform: 'scale(0.0)' })),
      transition('1 => 0', animate('300ms')),
      transition('0 => 1', animate('900ms'))
    ])
  ]
})

export class SurveyComponent implements OnDestroy, OnInit, AfterViewInit, OnChanges {

  config: any;
  private id: any;
  survey: SurveyConfig;
  surveyResult: ResultSurvey;
  visibility = 'shown';
  constructor(
    private changeDetectionRef: ChangeDetectorRef,
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private surveyServices: SurveyService,
    private languagePipe: LanguagePipe,
    private toastService: ToastService) { }


  ngOnInit() {

    this.route
      .params
      .map(params => params)
      .do(params => this.id = +params['id'])
      .subscribe(params => {
        this.getSurvey();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('promene', changes);
    this.visibility = this.surveyResult == null ? 'shown' : 'hidden';
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }


  onSubmit(event) {

    let survey = { questions: [], surveyId: this.survey.id};
    let objectProps: string[] = Object.keys(event);

    for (let i = 0; i < objectProps.length; i++) {
      let question = {};
      let objectProp = objectProps[i];
      let objectPropValue = Array.isArray(event[objectProp]) ? event[objectProp] : event[objectProp].split();

      question['id'] = objectProp;
      question['answers'] = objectPropValue;

      survey.questions.push(question);
    }

    this.surveyServices.saveSurveyData(survey)
      .subscribe((response: OperationResult) => {
        if (response.success == true) {
          this.getSurveyResult();
        } else {

        }
      });
  }

  onChanges(event) {
  }

  getSurveyResult() {
    this.surveyServices.getSurveyResult(this.id)
      .subscribe(result => {
        this.surveyResult = null;
        this.surveyResult = result.result;
        this.surveyResult.message = result.message;
      });
  }

  private getSurvey() {
    this.surveyServices.getSurvey(this.id)
      .subscribe(survey => {
        this.survey = survey;
        this.config = {};
        this.config['questions'] = survey.questions;
        this.config['settings'] = { submitButtonText: `<span><i class='fa fa-pencil-square-o' aria-hidden='true'>&nbsp;</i>${this.languagePipe.transform('SurveyConfirmAndSendData', null)}</span>` };//survey.settings;
        this.config['classes'] = survey.classes;
        this.config['other'] = survey.other;
      });
  }

  private gotoSurveys() {
    this.router.navigate(['/surveys']);
  }
}



// WEBPACK FOOTER //
// ./src/app/surveys/survey/survey.component.ts